import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8278_16995)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.00012 3.40417C5.46594 3.40417 3.4043 5.46582 3.4043 8C3.4043 10.5342 5.46594 12.5958 8.00012 12.5958C10.5343 12.5958 12.5959 10.5342 12.5959 8C12.5959 5.46582 10.5343 3.40417 8.00012 3.40417Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.99951 2.30969C8.26562 2.30969 8.48145 2.09387 8.48145 1.82776V0.481934C8.48145 0.21582 8.26562 0 7.99951 0C7.7334 0 7.51758 0.21582 7.51758 0.481934V1.82776C7.51758 2.09387 7.7334 2.30969 7.99951 2.30969Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.99951 13.6903C7.7334 13.6903 7.51758 13.9061 7.51758 14.1722V15.5181C7.51758 15.7842 7.7334 16 7.99951 16C8.26562 16 8.48145 15.7842 8.48145 15.5181V14.1722C8.48145 13.9061 8.26562 13.6903 7.99951 13.6903Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7055 3.97629L13.6572 3.02463C13.8454 2.83652 13.8454 2.53134 13.6572 2.34311C13.4689 2.15488 13.1638 2.15488 12.9756 2.34311L12.024 3.29477C11.8358 3.483 11.8358 3.78806 12.024 3.97629C12.2121 4.16452 12.5173 4.16452 12.7055 3.97629Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.29498 12.0237L2.34332 12.9753C2.15509 13.1635 2.15509 13.4686 2.34332 13.6569C2.53156 13.845 2.83673 13.8451 3.02484 13.6569L3.9765 12.7052C4.16473 12.517 4.16473 12.2119 3.9765 12.0237C3.78827 11.8354 3.48322 11.8354 3.29498 12.0237Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5182 7.51804H14.1724C13.9061 7.51804 13.6904 7.73386 13.6904 7.99997C13.6904 8.26608 13.9061 8.4819 14.1724 8.4819H15.5182C15.7843 8.4819 16.0001 8.26608 16.0001 7.99997C16.0001 7.73386 15.7843 7.51804 15.5182 7.51804Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.82776 7.51804H0.481934C0.21582 7.51804 0 7.73386 0 7.99997C0 8.26608 0.21582 8.4819 0.481934 8.4819H1.82776C2.09387 8.4819 2.30969 8.26608 2.30969 7.99997C2.30969 7.73386 2.09387 7.51804 1.82776 7.51804Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7055 12.0237C12.5173 11.8354 12.2122 11.8354 12.024 12.0237C11.8358 12.2119 11.8358 12.517 12.024 12.7052L12.9756 13.6569C13.1638 13.845 13.4689 13.8451 13.6572 13.6569C13.8454 13.4686 13.8454 13.1635 13.6572 12.9753L12.7055 12.0237Z",
				fill: "#111111"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.29498 3.97629C3.48322 4.16452 3.78827 4.16452 3.9765 3.97629C4.16473 3.78806 4.16473 3.483 3.9765 3.29477L3.02484 2.34311C2.83673 2.15488 2.53156 2.15488 2.34332 2.34311C2.15509 2.53134 2.15509 2.83652 2.34332 3.02463L3.29498 3.97629Z",
				fill: "#111111"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8278_16995",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgSunIcon);
export default ForwardRef;
